var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-map-report"},[_c('div',{staticClass:"not-found-message-container"},[_c('p',[_vm._v("レポートデータが見つかりませんでした。")]),_c('p',[_vm._v("お手数ですが、担当者までお問い合わせください。")])])])
}]

export { render, staticRenderFns }